<template>
  <el-dialog
    :title="`${title}员工`"
    body-type="tip"
    width="234px"
    footer-padding="0 30px 15px"
    :visible="visible"
    class="create-staff-box"
    :before-close="close"
  >
    <el-form
      ref="baseForm"
      :model="baseInfo"
      :rules="baseRules"
      label-position="right"
      label-width="85px"
      class="base-box"
      :disabled="!canEditor"
    >
      <el-form-item label="员工姓名：" prop="name" class="form-item">
        <el-input v-model.trim="baseInfo.name" class="w255" :maxlength="20" placeholder="请输入2-20位员工姓名"></el-input>
      </el-form-item>
      <el-form-item label="手机号：" prop="phone" class="form-item" >
        <el-input v-model.trim="baseInfo.phone" class="w255" :maxlength="11" placeholder="请输入手机号">
          <template slot="prepend">中国 +86</template>
        </el-input>
        <p v-if="employeeId && canEditor" class="other-tip">更换手机号后需要重新邀请员工</p>
      </el-form-item>
      <el-form-item label="员工性别：" prop="gender">
        <el-select v-model="baseInfo.gender" placeholder="请选择性别" class="w255">
          <el-option label="男" :value="1"></el-option>
          <el-option label="女" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="邮箱：" prop="email" class="form-item">
        <el-input v-model.trim="baseInfo.email" class="w255" placeholder="请输入邮箱"></el-input>
      </el-form-item>
      <el-form-item label="部门：" prop="department" class="form-item">
        <el-cascader
          v-model="baseInfo.department"
          :options="departments"
          :props="{
            value: 'deptId',
            label: 'deptName',
            checkStrictly: true,
          }"
          class="w255"
        ></el-cascader>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="!employeeId && canEditor" type="primary" size="small" auto-width clstag="pageclick|keycount|staff_list|createStaff_sendMsg" @click="checkInfo('invite')">发送短信邀请</el-button>
      <el-button v-if="!employeeId && canEditor" functional size="small" auto-width clstag="pageclick|keycount|staff_list|createStaff_create" @click="checkInfo('create')">仅新建</el-button>
      <el-button v-if="employeeId && canEditor" functional size="small" auto-width clstag="pageclick|keycount|staff_list|op_modifyInfo_save" @click="checkInfo('update')">保存</el-button>
      <el-button plain size="small" auto-width :clstag="`pageclick|keycount|staff_list|${cancelClstag}`" @click="close(false)">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  employeeInfo, employeeAdd, employeeUpdate, employeeInvite,
} from '@/api/apis/staff';
import { getAncestorIds } from '@/utils/tree';

export default {
  name: 'CreateStaff',
  props: {
    visible: Boolean,
    // 编辑员工id
    employeeId: Number,
    canEditor: {
      type: Boolean,
      default: true,
    },
    departments: {
      type: Array,
      default() {
        return [];
      },
    },
    departmentsArr: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    /**
     * 校验员工姓名
     * 规则：
     * 1. 4-20位字符
     * 2. 可使用字母、数字或符号（_-）的组合
     * 3. 不允许使用纯数字
     */
    const checkName = (rule, value, callback) => {
      const userReg = /^([\u4e00-\u9fa5.·]+|([a-zA-Z]+\s?)+)$/;
      if (!value || value === undefined) {
        callback(new Error('请输入员工姓名'));
      } else if (value.length < 2 || value.length > 20) {
        callback(new Error('请输入2-20位员工姓名'));
      } else if (!userReg.test(value)) {
        callback(new Error('不能含有特殊字符和数字'));
      }
      callback();
    };

    // 手机号校验
    const checkPhone = (rule, value, callback) => {
      const phoneReg = /^(0086)?1\d{10}$/;
      if (!value || value === undefined) {
        callback(new Error('请输入手机号'));
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号'));
      }
      callback();
    };

    // 邮箱校验
    const checkEmail = (rule, value, callback) => {
      // eslint-disable-next-line no-useless-escape
      const emailReg = /^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/;
      if (!value || value === undefined) {
        // callback(new Error('请输入邮箱'));
      } else if (!emailReg.test(value)) {
        callback(new Error('请输入正确的邮箱'));
      }
      callback();
    };

    return {
      employeeInfo: {
        employeeId: null,
      },
      baseInfo: {
        name: '',
        phone: '',
        gender: 1,
        email: '',
        department: [],
      },
      baseRules: {
        name: [
          { required: true, validator: checkName, trigger: 'change' },
        ],
        phone: [
          { required: true, validator: checkPhone, trigger: 'change' },
        ],
        gender: [
          { required: true, message: '请选择员工性别', trigger: 'change' },
        ],
        email: [
          { validator: checkEmail, trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    title() {
      let title = this.employeeId ? '修改' : '新建';
      title = !this.canEditor ? '查看' : title;
      return title;
    },
    cancelClstag() { // 取消埋点
      let tag = 'op_lookInfo_cancel';
      if (!this.employeeId && this.canEditor) {
        tag = 'createStaff_cancel';
      } else if (this.employeeId && this.canEditor) {
        tag = 'op_modifyInfo_cancel';
      }
      return tag;
    },
  },
  created() {
    if (this.employeeId) {
      this.getStaffInfo();
    }
  },
  methods: {
    // 查询员工信息
    async getStaffInfo() {
      const res = await employeeInfo({ id: this.employeeId });
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        this.employeeInfo = { ...this.employeeInfo, ...data };
        this.baseInfo.name = this.employeeInfo.name;
        this.baseInfo.phone = this.employeeInfo.phone;
        this.baseInfo.email = this.employeeInfo.email;
        this.baseInfo.gender = this.employeeInfo.gender !== 'null' ? Number(this.employeeInfo.gender) : 1;
        this.baseInfo.department = getAncestorIds({
          id: this.employeeInfo.deptId,
          nodes: this.departmentsArr,
          idKey: 'deptId',
          pidKey: 'parentId',
          rootId: 0,
        });
      } else {
        this.$message.error(message || '获取员工基础信息失败！');
      }
    },
    // 关闭新建
    close(isInit) {
      this.$emit('closeCreate', isInit);
    },
    checkInfo(type) {
      this.$refs.baseForm.validate(async (valid) => {
        if (valid) {
          this.create(type);
        }
      });
    },
    // 创建员工
    async create(type) {
      const baseInfo = {
        ...this.baseInfo,
        deptId: this.baseInfo.department[this.baseInfo.department.length - 1],
      };
      delete baseInfo.department;
      const res = type === 'update' ? await employeeUpdate({ ...baseInfo, id: this.employeeId }) : await employeeAdd(baseInfo);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        // 是否是仅创建
        if (type === 'create' || type === 'update') {
          this.$message({
            message: type === 'update' ? '修改已保存' : '员工创建成功，请及时发送邀请',
            type: 'success',
            onClose: () => {
              this.close(true);
            },
          });
        } else {
          this.invite(data.employeeId);
        }
      } else {
        this.$message.error(message || '创建失败请稍后重试！');
      }
    },
    // 发送邀请验证码
    async invite(employeeId) {
      const res = await employeeInvite({ employeeId });
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        this.$message({
          message: '已发送邀请',
          type: 'success',
          onClose: () => {
            this.close(true);
          },
        });
      } else {
        this.$message.error(message || '发送邀请失败，请稍后重试！');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.create-staff-box {
  .el-form-item {
    // margin-bottom: 18px;
  }
  .other-tip {
    padding-top: 5px;
    font-size: 12px;
    line-height: 17px;
    color: rgba(0,0,0,0.45);
  }
  .w255 {
    width: 255px;
  }
}
</style>
<style lang="scss">
.create-staff-box .el-dialog{
  min-width: 400px;
}
</style>
